import React from "react";

import PropTypes from "prop-types";
import WorkHistory from "./WorkHistory/WorkHistory";
import Education from "./Education/Education";
import Objective from "./Objective/Objective";
import Skills from "./Skills/Skills";
import Interests from "./Interests/Interests";
import styles from "./Resume.css";

const resume = ({ display, details }) => {
  let displayClass = [styles.Resume, styles.ResumeActive];
  if (!display) {
    displayClass = [styles.Resume, styles.ResumeHidden];
  }

  let pdfClass = [styles.pdf, styles.pdfActive];
  if (!display) {
    pdfClass = [styles.pdf, styles.pdfHidden];
  }

  return (
    <div className={displayClass.join(" ")}>
      <div className={styles.expCol}>
        <Objective summary={details.summary} />
        <WorkHistory history={details.workHistory} />
        <Interests interests={details.interests} />
      </div>
      <div className={styles.skillCol}>
        <Education education={details.educationHistory} />
        <Skills skills={details.skills} />

        <div className={pdfClass.join(" ")}>
          <p className={styles.pdfText}>
            <a href="https://s3.amazonaws.com/cmcgill.io/resume.pdf" download>
              Click for PDF Version!
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

resume.propTypes = {
  display: PropTypes.bool.isRequired,
  details: PropTypes.shape({
    summary: PropTypes.string.isRequired,
    workHistory: PropTypes.array.isRequired,
    educationHistory: PropTypes.array.isRequired,
    skills: PropTypes.array.isRequired,
    interests: PropTypes.array.isRequired
  }).isRequired
};

export default resume;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Resume.js